/**
 * @param {jQuery} $ jQuery object.
 */
(function( $ ) {

	/**
	 * Toggle active class.
	 *
	 * @since 1.0.0
	 */
	function toggleActive( item ) {
		var $item = $(item);

		$item.parents( '.gfield_radio' ).find( 'li' ).removeClass( 'is--active' );
		$item.parents( 'li' ).toggleClass( 'is--active', $item.is( ':checked' ) );
	}

	function addAttachmentsButton() {
		var $input = $( '#message_attachment' );
		var $label = $( '.hsd-form-attachment-count' );

		$input.on( 'change', function(e) {
			var fileName = '';

			$label.css( 'display', 'inline-block' ).html( this.files.length );
		});
	};

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {
		/**
		 * Gravity Forms
		 */
		$( '.gfield--dual-radio-green li' ).on( 'click', function() {
			var $input = $(this).find( 'input[type="radio"]' );
			$input.attr( 'checked', true ).triggerHandler( 'click' );

			toggleActive( $input );
		} );

		$( '.gfield--dual-radio-green input[type="radio"]' ).on( 'change', function() {
			toggleActive( $(this) );
		});

		toggleActive( '.gfield--dual-radio-green input[type="radio"]:checked' );

		/**
		 * Custom conversation reply attachment button.
		 *
		 * @since 1.3.0
		 */
		addAttachmentsButton();

		/**
		 * Hide HSD conversation reply on closed topics.
		 *
		 * @since 1.3.0
		 */
		$( '#hsd_conversations_table' ).on( 'hsd_post_success_conversation', function() {
			var $item_status = $( '#hsd_support_conversation' ).data( 'item-status' );

			if ( $item_status === 'closed' ) {
				$( '#hsd_message_form' ).hide();
			};
		});
	});

})( jQuery );
